import { Link } from 'react-router-dom';

const stats = [
  { value: '9+', label: '主要登场角色' },
  { value: '12+', label: '守护甜心' },
  { value: '16+', label: '配音演员' },
  { value: '3季', label: 'TV动画' },
];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[560px] w-full md:h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20dreamy%20pastel%20anime%20landscape%20illustration%20of%20a%20magical%20sky%20filled%20with%20floating%20sakura%20petals%2C%20glowing%20heart%20shaped%20lights%20and%20sparkling%20stars%2C%20golden%20warm%20sunset%20clouds%2C%20a%20dreamy%20shoujo%20magical%20atmosphere%2C%20gentle%20warm%20color%20palette%20of%20pink%20and%20cream%2C%20ethereal%20soft%20lighting%2C%20cinematic%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=home-hero-01&orientation=landscape"
          alt="守护甜心动漫梦幻樱花与爱心天空插画背景"
          className="absolute inset-0 h-full w-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/20 to-background-50"></div>

        <div className="relative z-10 mx-auto flex h-full w-full max-w-7xl flex-col items-center justify-center px-4 text-center md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/80 px-4 py-1.5 text-sm font-medium text-primary-600 backdrop-blur-sm">
            <i className="ri-heart-3-fill text-primary-500" aria-hidden="true"></i>
            心灵之蛋 · 角色变换 · 守护成长
          </span>
          <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-foreground-900 md:text-5xl">
            守护甜心动漫<span className="text-primary-500">角色大全</span>
            <span className="block text-2xl font-bold text-foreground-700 md:text-3xl">与声优表全收录</span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
            日奈森亚梦、月咏几斗、边里唯世……主要角色的背景故事一次集齐，
            同时附上守护甜心动漫声优表与配音演员对应信息。想查角色、对声优，直接对号入座。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/characters"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 shadow-md transition-colors hover:bg-primary-600"
            >
              <i className="ri-team-line" aria-hidden="true"></i>
              浏览角色大全
            </Link>
            <Link
              to="/voice-actors"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-700/30 bg-background-50/80 px-7 py-3 text-sm font-semibold text-foreground-800 backdrop-blur-sm transition-colors hover:bg-background-100"
            >
              <i className="ri-mic-line" aria-hidden="true"></i>
              查看声优表
            </Link>
          </div>

          <dl className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-xl bg-background-50/75 px-3 py-4 backdrop-blur-sm border border-background-200/70"
              >
                <dt className="order-2 mt-1 block text-xs text-foreground-500">{s.label}</dt>
                <dd className="font-heading text-2xl font-black text-primary-600">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}